import { isNil } from '@roc/feature-utils';
import { Button, EditableDialog, EditableDrawer } from '@roc/ui';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { AppraisalTaskContent, EscalateButton, MarkTaskAsCompletedButton, MarkTaskAsWaitingOnExternalButton, MoveTaskToRocButton, TaskDialogContent, useEditAppraisalTask, useEditGeneralTask } from './commonEditTask';
import { Box, Grid } from '@material-ui/core';

export const EditGeneralTask = observer(() => {
  const { store, classes, selectedTabIndex, getTitle, onTabChange } = useEditGeneralTask();

  return (
    <>
      <TaskDialogContent selectedTabIndex={selectedTabIndex} onTabChange={onTabChange} classes={classes} />
      <Box display="flex" flexDirection="row" justifyContent="end" marginTop="15px" marginRight="30px">
        <EscalateButton />
        <MoveTaskToRocButton />
        <MarkTaskAsCompletedButton />
        <Button
          onClick={e => {
            {
              store.saveTaskWithMessageNportalIframe();
            }
          }}
          color="primary"
          variant="contained"
          testId="save"
        >
          Save
        </Button>
      </Box>
    </>

  );
});

export const EditAppraisalTask = observer(() => {
  const { store, classes, selectedTabIndex, getTitle, onTabChange, globalStore } = useEditAppraisalTask();
  return (
    <>
      <AppraisalTaskContent selectedTabIndex={selectedTabIndex} onTabChange={onTabChange} classes={classes} store={store} globalStore={globalStore} />
      <Box display="flex" flexDirection="row" justifyContent="end" marginTop="15px" marginRight="30px">
        <MoveTaskToRocButton />
        <MarkTaskAsCompletedButton />
        <Button
          onClick={e => {
            {
              store.saveTaskWithMessageNportalIframe();
            }
          }}
          color="primary"
          variant="contained"
          testId="save"
        >
          Save
        </Button>
      </Box>
    </>
  );
});

export const EditTask = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;

  return (
    editTaskStore.isAppraisalTaskType ?
      <EditAppraisalTask /> :
      <EditGeneralTask />
  );
});
